<template>
    <div class="info">

    </div>
  </template>
  <script>

  export default {
    data() {
      return {
      
      }
    },
    mounted() {
    
    },
    methods: {
  
  
    }
  }
  </script>
  <style lang="less" scoped>
    
  </style>